/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-types */

import { AiDisclaimerRequestDto, DirectDisclaimerResponseDto, DisclaimerTargetResponse, DisclaimerTextResponseDto, GetDisclaimerRequest, ShortUrlEntity, ShortUrlRequest, TenantLite } from './models';

import {
  applyAiDisclaimerServer,
  applyDisclaimerServer,
  fetchTenantInfoLiteServer,
  getDisclaimerTargetServer,
  getDisclaimerTextInfoServer,
  getShortUrlTargetServer,
  isDirectDisclaimerForGuidServer,
  isDirectDisclaimerServer,
  validateSalesTokenServer
} from './server/api-server';

export async function applyAiDisclaimer(request: AiDisclaimerRequestDto) {
  return applyAiDisclaimerServer(request);
}


export async function getDisclaimerTarget(
  request: ShortUrlRequest
): Promise<DisclaimerTargetResponse> {
  return getDisclaimerTargetServer(request);
}

export async function isDirectDisclaimer(): Promise<Boolean> {
  return isDirectDisclaimerServer();
}
export async function isDirectDisclaimerForGuid(
  guid: string
): Promise<DirectDisclaimerResponseDto> {
  return isDirectDisclaimerForGuidServer(guid);
}

export async function getShortUrlTarget(
  request: ShortUrlRequest
): Promise<ShortUrlEntity> {
  return getShortUrlTargetServer(request);
}

export async function applyDisclaimer(
  request: ShortUrlRequest
): Promise<DisclaimerTargetResponse> {
  return applyDisclaimerServer(request);
}


export async function fetchTenantInfoLite(
    languageCode?: string
  ): Promise<TenantLite> {
    return fetchTenantInfoLiteServer(languageCode);
  }
  
  export async function getDisclaimerText(
    request: GetDisclaimerRequest)
    : Promise<DisclaimerTextResponseDto> {
    return getDisclaimerTextInfoServer(request);
  }
  
  export async function validateSalesToken(salesToken: string): Promise<boolean> {
    return validateSalesTokenServer(salesToken);
  }
